import { render } from "./generalsettings.vue?vue&type=template&id=0b95d6b4"
import script from "./generalsettings.vue?vue&type=script&lang=js"
export * from "./generalsettings.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GigLabs\\CIMS\\CIMS-MakProd\\gig.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__